// extracted by mini-css-extract-plugin
module.exports = {"Support":"G_Support__UwcKP"};